import { isPersonYoungerThan18 } from '@dvag/dfs-ui-blocks/utils';

import { useGetHouseholdDashboard } from 'hooks/useGetHouseholdDashboard';
import { hasApprovedConsent } from 'utils/util';

export type ServiceAnalyseConsentState = 'loading' | 'none' | 'partial' | 'full';

export const useServiceAnalyseConsentState = (): ServiceAnalyseConsentState => {
  const { data, isFetched } = useGetHouseholdDashboard();

  if (!isFetched || !data) {
    return 'loading';
  }

  const consentList = data.consentList ?? [];
  const adults = (data.personList ?? []).filter(
    (person) => !isPersonYoungerThan18(person.birthDate ?? undefined),
  );
  const total = adults.length;
  const approved = adults.filter((person) =>
    consentList.some(
      (consent) => consent.personId === person.id && hasApprovedConsent(consent.status),
    ),
  ).length;

  if (total === 0 || approved === 0) {
    return 'none';
  }
  if (approved < total) {
    return 'partial';
  }
  return 'full';
};
